
















































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { IUserProfile } from '@/interfaces';
import { readHasAdminAccess } from '@/store/main/getters';
import { IContract } from '@/interfaces';
import { readAdminContracts } from '@/store/contract/getters';
import { dispatchGetContracts, dispatchInviteContract } from '@/store/contract/actions';
import { readAdminOneUser } from '@/store/admin/getters';

@Component
export default class ContractList extends Vue {
  public headers() {
    const hdrs = [
      {
        text: 'Client Email',
        sortable: true,
        value: 'client_email',
        align: 'left',
      },
      {
        text: 'Mac Addr',
        sortable: true,
        value: 'mac',
        align: 'left',
      },
      {
        text: 'Key(s)',
        sortable: true,
        value: 'key1',
        align: 'center',
      },
      {
        text: 'Comments',
        sortable: false,
        value: 'comment',
        align: 'left',
      },
      {
        text: 'Activated',
        sortable: true,
        value: 'last_activated',
        align: 'left',
      },
      {
        text: 'Last seen',
        sortable: true,
        value: 'last_seen',
        align: 'left',
      },
      {
        text: 'Actions',
        value: 'key1',
        align: 'center',
      },
    ];

    if (this.is_super_user()) {
      hdrs.splice(0, 0, {
        text: 'Distributeur',
        sortable: true,
        value: 'owner_id',
        align: 'left',
      });
    }
    return hdrs;
  }


  public user_name(id: number) {
    const readUser = readAdminOneUser(this.$store)(id);
    if (readUser && readUser.full_name) {
      return readUser.full_name;
    } else {
      return id;
    }
  }

  get contracts() {
    return readAdminContracts(this.$store);
  }

  public is_super_user() {
    return readHasAdminAccess(this.$store);
  }

  public async mounted() {
    await dispatchGetContracts(this.$store);
  }

  public async submit_invite(key1: string) {
    await dispatchInviteContract(this.$store, key1);
  }


}
